<!-- Barra de carga mejorada - Solo para exportación a Excel -->
<div *ngIf="loading && loadingMessage.includes('Excel')"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white p-6 rounded-lg shadow-lg text-center w-96">
    <h3 class="text-xl font-bold mb-4">{{ loadingMessage }}</h3>
    <div class="w-full bg-gray-200 rounded-full h-4 mb-4">
      <div class="bg-blue-600 h-4 rounded-full transition-all duration-300 ease-in-out"
        [style.width.%]="loadingProgress"></div>
    </div>
    <p class="text-gray-700">{{ loadingDetail }}</p>
  </div>
</div>


<!-- Información de totales -->
<div class="flex justify-between items-center mb-2 bg-gray-100 p-2 rounded-lg shadow-sm mx-1">
  <div class="flex items-center space-x-2">
    <span class="font-semibold">Órdenes:</span>
    <span class="bg-blue-100 text-blue-800 px-2 py-1 rounded">
      {{ filteredTotal }} / {{ totalOrdersInDB }}
    </span>
    <span class="text-gray-500 text-sm">(filtradas / total)</span>
  </div>

  <div class="flex items-center space-x-2">
    <span class="font-semibold">Repuestos:</span>
    <span class="bg-green-100 text-green-800 px-2 py-1 rounded">
      {{ countTotalSpareParts() }}
    </span>
    <span class="text-gray-500 text-sm">(en órdenes mostradas)</span>
  </div>

  <div class="flex items-center space-x-2">
    <button (click)="forceReload()"
      class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded flex items-center space-x-1 mr-2"
      [disabled]="loading" title="Recargar todos los datos desde la base de datos">
      <i class="fas fa-sync-alt mr-1"></i>
      <span>Recargar Datos</span>
    </button>

    <button (click)="copyFilteredOrdersForWhatsapp()"
      class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded flex items-center space-x-1 mr-2"
      [disabled]="loading || isCopyingWhatsappOrders"
      title="Copiar al portapapeles las órdenes filtradas para WhatsApp">
      <i class="fab fa-whatsapp mr-1"></i>
      <span>{{ isCopyingWhatsappOrders ? 'Copiando...' : 'Copiar para WhatsApp' }}</span>
    </button>

    <button *ngIf="hasAnyOrderColumnFilter" (click)="clearAllOrderColumnFilters()"
      class="bg-red-100 hover:bg-red-200 text-red-700 px-4 py-2 rounded flex items-center space-x-1 mr-2"
      title="Quitar todos los filtros por columna">
      <i class="fas fa-filter-circle-xmark mr-1"></i>
      <span>Limpiar todos los filtros</span>
    </button>
    <div class="relative inline-block mr-2" #columnSelectorContainer>
      <button type="button" (click)="toggleColumnSelector(); $event.stopPropagation()"
        class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded flex items-center space-x-1"
        title="Mostrar u ocultar columnas">
        <i class="fas fa-table-columns"></i>
        <span>Columnas</span>
      </button>
      <div *ngIf="columnSelectorOpen"
        class="absolute right-0 mt-2 w-72 bg-white border border-gray-200 rounded-md shadow-lg z-50 p-3"
        (click)="$event.stopPropagation()">
        <div class="text-xs font-semibold text-gray-500 uppercase mb-2">Columnas visibles</div>
        <div class="max-h-64 overflow-y-auto pr-1">
          <label *ngFor="let column of columnVisibilityOptions"
            class="flex items-center gap-2 text-sm py-1 cursor-pointer hover:text-blue-700">
            <input type="checkbox" [checked]="isColumnVisible(column.id)" (change)="toggleColumnVisibility(column.id)">
            <span>{{ column.label }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Dropdown de acciones de exportación -->
    <div class="relative inline-block text-left" #exportDropdownContainer>
      <button (click)="toggleExportDropdown(); $event.stopPropagation()"
        class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded flex items-center space-x-1"
        [disabled]="loading">
        <i class="fas fa-download"></i>
        <span>Exportar</span>
        <i class="fas fa-chevron-down ml-1"></i>
      </button>

      <!-- Dropdown menu -->
      <div *ngIf="showExportDropdown"
        class="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-50"
        (click)="$event.stopPropagation()">
        <div class="py-1">
          <button (click)="exportToExcel(); $event.stopPropagation()"
            class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
            <i class="fas fa-file-excel mr-2 text-green-600"></i>
            Excel EXPORT
          </button>
          <button (click)="openCreateFolderDialog(); $event.stopPropagation()"
            class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center">
            <i class="fas fa-folder-plus mr-2 text-blue-600"></i>
            Crear Carpeta Exportada
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Paginación (Encima de la tabla) -->
<div class="pagination-container mb-2 bg-gray-50 p-3 rounded-lg shadow-sm mx-1" *ngIf="filteredTotal > 0">
  <div class="pagination-info text-center mb-2">
    <span class="font-semibold">Página {{ currentPage }} de {{ totalPages }} ({{ filteredTotal }} órdenes)</span>
  </div>

  <div class="pagination flex justify-center items-center">
    <button [disabled]="currentPage === 1" (click)="goToPage(1)"
      class="pagination-button bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded mx-1 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Primera página">
      &laquo;
    </button>
    <button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"
      class="pagination-button bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded mx-1 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Página anterior">
      &lsaquo;
    </button>

    <!-- Números de página -->
    <div class="page-numbers flex mx-2">
      <ng-container *ngFor="let page of getPageNumbers(); trackBy: trackByIndex">
        <!-- Puntos suspensivos -->
        <span *ngIf="page === -1" class="w-8 h-8 flex items-center justify-center mx-1">
          ...
        </span>

        <!-- Botón de página normal -->
        <button *ngIf="page !== -1" [class.bg-blue-500]="page === currentPage" [class.text-white]="page === currentPage"
          [class.font-bold]="page === currentPage" [class.bg-gray-200]="page !== currentPage"
          [class.hover:bg-gray-300]="page !== currentPage" (click)="goToPage(page)"
          class="page-number-button w-8 h-8 flex items-center justify-center rounded mx-1">
          {{ page }}
        </button>
      </ng-container>
    </div>

    <button [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)"
      class="pagination-button bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded mx-1 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Página siguiente">
      &rsaquo;
    </button>
    <button [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)"
      class="pagination-button bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded mx-1 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Última página">
      &raquo;
    </button>
  </div>

  <!-- Filtros y tamaño de página -->
  <div class="mt-4 flex flex-wrap justify-center items-center gap-4">
    <!-- Selector de tamaño de página -->
    <div class="flex items-center">
      <span class="mr-2">Mostrar:</span>
      <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="border rounded px-2 py-1">
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
      <span class="ml-2">por página</span>
    </div>

    <!-- Selector de taller -->
    <div class="flex items-center">
      <span class="mr-2">Taller:</span>
      <select [(ngModel)]="selectedWorkshopId" (change)="onWorkshopFilterChange()" class="border rounded px-2 py-1">
        <option [value]="null">Todos los talleres</option>
        <option *ngFor="let workshop of workshops" [value]="workshop.workshopId">
          {{ workshop.name }}
        </option>
      </select>
    </div>
  </div>
</div>

<!-- Tabla de Órdenes -->
<div class="table-responsive-container table-fixed-header table-scroll-horizontal h-[calc(100vh-250px)] mx-1 orders-main-table-wrapper">
  <!-- Indicador de carga simple para cambio de página -->
  <div *ngIf="loading && !loadingMessage.includes('Excel')" class="table-loading">
    <div class="table-loading-spinner"></div>
    <span class="ml-2">Cargando datos...</span>
  </div>

  <!-- Tabla de Órdenes Filtradas -->
  <div *ngIf="!loading || loadingMessage.includes('Excel')">
    <table class="table-responsive table-mobile-cards table-fade-in orders-main-table">
      <thead class="sticky-header">
        <tr class="bg-gray-100">
          <th class="order-row-index-header px-4 py-2" scope="col" title="Número de fila">#</th>
          <th class="px-4 py-2" scope="col" aria-label="Selección">
            <input type="checkbox" [(ngModel)]="ordersTableAllSelected" (change)="toggleAllOrdersTableSelection()">
          </th>
          <th class="px-4 py-2 w-8"></th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Cliente Uy')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Cliente Uy')">Cliente Uy</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('clienteUY'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'clienteUY'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'clienteUY'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Fecha de Creación')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Fecha de Creación')">Fecha de Creación</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('creationDate'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'creationDate'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'creationDate'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Orden')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Orden')">Orden</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('orderNumber'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'orderNumber'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'orderNumber'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Siniestro')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Siniestro')">Siniestro</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('siniestro'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'siniestro'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'siniestro'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Factura')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Factura')">Factura</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('invoiceNumber'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'invoiceNumber'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'invoiceNumber'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Cliente')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Cliente')">Cliente</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('clientName'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'clientName'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'clientName'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Proveedor')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Proveedor')">Proveedor</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('providerName'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'providerName'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'providerName'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Estado')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Estado')">Estado</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('stateOrder'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'stateOrder'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'stateOrder'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Fecha de Llegada')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Fecha de Llegada')">Fecha de Llegada</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('expectedArrivalDate'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'expectedArrivalDate'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'expectedArrivalDate'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Dias de atraso')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Dias de atraso')">Dias de atraso</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Dias de plazo')"
            title="Mínimo de plazos (emisión de orden → F. Esp. de cada repuesto)">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Dias de plazo')">Dias de plazo</span>
            </div>
          </th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Vendedor')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Vendedor')">Vendedor</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('employeeName'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'employeeName'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'employeeName'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
          <th class="px-4 py-2">Repuestos</th>
          <th class="px-4 py-2 sortable-header" [class.column-filter-active]="isOrderColumnFiltered('Costo')">
            <div class="header-content">
              <span class="header-label cursor-pointer hover:text-blue-600" (click)="showColumnFilter($event, 'Costo')">Costo</span>
              <i class="fas fa-sort sort-icon" (click)="sortData('estimatedCost'); $event.stopPropagation()" [class.text-blue-600]="sortedBy === 'estimatedCost'" title="Ordenar"></i>
              <span *ngIf="sortedBy === 'estimatedCost'" class="sort-indicator">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of filteredOrdersList; let rowIndex = index; trackBy: trackByOrderId" class="border-b hover:bg-gray-50 cursor-pointer"
          [ngClass]="[getOrderRowClass(order), order.orderId === activeFocusedOrderId ? 'active-focused-row' : '']" (click)="openModal(order)">
          <td class="order-row-index-cell px-4 py-2" data-label="#">{{ order.orderId ?? '-' }}</td>
          <td class="px-4 py-2" data-label="Selección" (click)="$event.stopPropagation()">
            <div class="flex items-center gap-2">
              <input type="checkbox" [(ngModel)]="order.selected" (change)="onOrderTableRowSelectionChange()">
              <button type="button" class="text-indigo-600 hover:text-indigo-800 text-xs"
                title="Duplicar orden" (click)="onDuplicateOrderFromTable(order, $event)">
                <i class="fas fa-clone"></i>
              </button>
            </div>
          </td>
          <td class="px-4 py-2 text-left"
            [ngClass]="getOrderDelayCellClass(order)" data-label="Estado">
            <div class="flex flex-col items-start">
              <i *ngIf="hasOrderDelayAlert(order)"
                class="fas fa-exclamation-triangle cursor-pointer"
                [ngClass]="getOrderDelayIconClass(order)"
                title="Atraso detectado. Haz clic para ocultar esta alerta en esta sesión." tabindex="0"
                (click)="dismissOrderDelayAlert($event, order)" (keyup.enter)="dismissOrderDelayAlert($event, order)"></i>
              <span class="text-xs mt-1" *ngIf="order.orderStatus">
                {{ getStatusIcon(order.orderStatus) }}
              </span>
            </div>
          </td>
          <td class="px-4 py-2" data-label="Cliente Uy">{{ order.clienteUY || '—' }}</td>
          <td class="px-4 py-2" data-label="Fecha de Creación">{{ order.creationDate | date:'dd/MM/yyyy' }}</td>
          <td class="px-4 py-2 font-medium" data-label="Orden">{{ order.orderNumber }}</td>
          <td class="px-4 py-2" data-label="Siniestro">{{ order.siniestro }}</td>
          <td class="px-4 py-2" data-label="Factura">{{ order.invoiceNumber }}</td>
          <td class="px-4 py-2" data-label="Cliente">{{ order.clientName }}</td>
          <td class="px-4 py-2" data-label="Proveedor">{{ order.providerName }}</td>
          <td class="px-4 py-2" data-label="Estado" [ngClass]="getStatusClass(order.orderStatus)">
            <span class="status-badge" [ngClass]="getStatusBadgeClass(order.orderStatus)">
              {{ order.orderStatus }}
            </span>
          </td>
          <td class="px-4 py-2"
            [ngClass]="{ 'font-bold': hasOrderDelayAlert(order) }"
            data-label="Fecha de Llegada">
            {{ order.expectedArrivalDate | date:'dd/MM/yyyy' }}
          </td>
          <td class="px-4 py-2" data-label="Dias de atraso">
            <div class="flex items-center gap-2">
              <span [ngClass]="getOrderDelayBadgeClass(order)">
                {{ getOrderDelayDays(order) }}
              </span>
              <button *ngIf="getOrderDelaySeverity(order) && !isOrderDelayDismissed(order)"
                type="button"
                class="text-gray-500 hover:text-gray-700 text-xs"
                title="Ocultar alerta en esta sesión"
                (click)="dismissOrderDelayAlert($event, order)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </td>
          <td class="px-4 py-2" data-label="Dias de plazo">{{ formatOrderMinDiasPrazo(order) }}</td>
          <td class="px-4 py-2" data-label="Empleado">{{ order.employeeName }}</td>
          <td class="px-4 py-2" data-label="Repuestos">{{ order.spareParts?.length || 0 }}</td>
          <td class="px-4 py-2" data-label="Costo">{{ getTotalCost(order) | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Overlay to close popup when clicking outside -->
<div *ngIf="showFilterPopup" class="fixed inset-0 z-40" (click)="closeFilterPopup(false)"></div>
<!-- Floating Filter Popup (multi-selección, altura dinámica para no cortarse) -->
<div *ngIf="showFilterPopup" class="fixed bg-white border-2 border-blue-500 rounded-lg shadow-2xl p-4 z-50 w-80 flex flex-col overflow-hidden"
  [style.left.px]="filterPopupPosition.x" [style.top.px]="filterPopupPosition.y"
  [style.max-height.px]="filterPopupMaxHeight" (click)="$event.stopPropagation()">
  <div class="mb-3 flex-shrink-0">
    <label class="block text-sm font-semibold text-gray-700 mb-2">
      Filtrar por {{ filterColumn }}
    </label>
    <input type="text" [(ngModel)]="filterValue" (ngModelChange)="onFilterInputChange()"
      (keyup.enter)="closeFilterPopup(true)"
      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
      placeholder="Buscar o escriba un valor..." />
    <button
      type="button"
      (click)="toggleAllOrderFilterValues()"
      [disabled]="loadingUniqueValues || filteredColumnValues.length === 0"
      class="mt-2 text-xs font-medium text-blue-600 hover:text-blue-700 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors">
      {{ areAllOrderFilterValuesSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
    </button>
  </div>

  <div class="mb-3 min-h-0 flex-1 overflow-y-auto border border-gray-200 rounded-md">
    <div *ngIf="loadingUniqueValues" class="p-3 text-sm text-gray-500 text-center">
      Cargando valores...
    </div>
    <div *ngIf="!loadingUniqueValues && filteredColumnValues.length === 0" class="p-3 text-sm text-gray-500 text-center">
      No se encontraron valores
    </div>
    <label *ngFor="let value of filteredColumnValues; trackBy: trackByIndex"
      class="flex items-center px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm border-b border-gray-100 last:border-b-0 transition-colors">
      <input type="checkbox" class="mr-2" [checked]="isOrderFilterValueSelected(value)"
        (change)="toggleOrderFilterValue(value, $event)">
      <span>{{ value }}</span>
    </label>
  </div>

  <div class="flex justify-end gap-2 flex-shrink-0 pt-1">
    <button (click)="closeFilterPopup(false)"
      class="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md transition-colors">
      Cancelar
    </button>
    <button (click)="clearAndApplyOrderColumnFilter()"
      class="px-4 py-2 text-sm bg-red-100 hover:bg-red-200 text-red-700 rounded-md transition-colors">
      Limpiar
    </button>
    <button (click)="closeFilterPopup(true)"
      class="px-4 py-2 text-sm bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors">
      <i class="fas fa-filter mr-1"></i>Aplicar
    </button>
  </div>
</div>

<!-- Panel de resumen debajo de la tabla de órdenes -->
<div class="mt-4 p-4 bg-white border rounded-lg shadow-sm" *ngIf="filteredOrdersList.length > 0">
  <h3 class="font-semibold text-lg mb-3">Resumen de órdenes</h3>
  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
    <div class="bg-blue-50 p-4 rounded-lg shadow-sm">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-500">Total de costos</p>
          <p class="text-2xl font-bold text-blue-700">{{ getTotalOrdersCost() | currency }}</p>
        </div>
        <div class="bg-blue-100 p-3 rounded-full">
          <i class="fas fa-dollar-sign text-blue-500 text-xl"></i>
        </div>
      </div>
    </div>

    <div class="bg-green-50 p-4 rounded-lg shadow-sm">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-500">Total de valor de venta</p>
          <p class="text-2xl font-bold text-green-700">{{ getTotalOrdersValue() | currency }}</p>
        </div>
        <div class="bg-green-100 p-3 rounded-full">
          <i class="fas fa-chart-line text-green-500 text-xl"></i>
        </div>
      </div>
    </div>

    <div class="bg-purple-50 p-4 rounded-lg shadow-sm">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-500">Total de repuestos</p>
          <p class="text-2xl font-bold text-purple-700">{{ getTotalSparePartsCount() }}</p>
        </div>
        <div class="bg-purple-100 p-3 rounded-full">
          <i class="fas fa-cogs text-purple-500 text-xl"></i>
        </div>
      </div>
    </div>
    <div class="bg-indigo-50 p-4 rounded-lg shadow-sm">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-500">Total de órdenes</p>
          <p class="text-2xl font-bold text-indigo-700">{{ getTotalOrdersCount() }}</p>
        </div>
        <div class="bg-indigo-100 p-3 rounded-full">
          <i class="fas fa-clipboard-list text-indigo-500 text-xl"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla de Repuestos (Todos) -->
<div class="mt-4">
  <div class="flex justify-between items-center mb-2">
    <h3 class="font-semibold text-lg">Repuestos de órdenes filtradas</h3>
    <button class="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600" (click)="showOrders = !showOrders">
      {{ showOrders ? 'Mostrar por repuestos' : 'Mostrar por órdenes' }}
    </button>
  </div>

  <div class="overflow-x-auto max-h-[400px] overflow-y-auto w-full border rounded-lg" *ngIf="!showOrders">
    <table class="min-w-full bg-white">
      <thead>
        <tr class="bg-gray-100">
          <th class="px-4 py-2">Nombre</th>
          <th class="px-4 py-2">🇪🇸 Español</th>
          <th class="px-4 py-2">🇧🇷 Portugués</th>
          <th class="px-4 py-2">Código</th>
          <th class="px-4 py-2">Estado</th>
          <th class="px-4 py-2">Orden</th>
          <th class="px-4 py-2">Cliente</th>
          <th class="px-4 py-2">Cantidad</th>
          <th class="px-4 py-2">Precio Unitario</th>
          <th class="px-4 py-2">Valor de Venta</th>
          <th class="px-4 py-2">Total</th>
          <th class="px-4 py-2">Fecha de Llegada</th>
          <th class="px-4 py-2">Código BR</th>
          <th class="px-4 py-2">Necesita Revisión</th>
          <th class="px-4 py-2">Núm. Paquete</th>
          <th class="px-4 py-2 text-center">Control</th>
          <th class="px-4 py-2 text-center">Anulado</th>
          <th class="px-4 py-2 text-center">Trello</th>
          <th class="px-4 py-2">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let part of getAllSpareParts(); trackBy: trackBySparePartId" class="border-b hover:bg-gray-50"
          [class.last-edited-row]="part.sparePartId === lastEditedSparePartId"
          [ngClass]="getOrderDetailSparePartRowClass(part)">
          <td class="px-4 py-2">{{ part.sparePartName }}</td>
          <td class="px-4 py-2">
            <span *ngIf="part.sparePartNameEs" class="text-blue-600 font-medium">{{ part.sparePartNameEs }}</span>
            <span *ngIf="!part.sparePartNameEs" class="text-gray-400 italic">No definido</span>
          </td>
          <td class="px-4 py-2">
            <span *ngIf="part.sparePartNamePt" class="text-green-600 font-medium">{{ part.sparePartNamePt }}</span>
            <span *ngIf="!part.sparePartNamePt" class="text-gray-400 italic">No definido</span>
          </td>
          <td class="px-4 py-2">{{ part.productCode }}</td>
          <td class="px-4 py-2" [ngClass]="getProductStatusClass(part.productStatus)">{{ part.productStatus }}</td>
          <td class="px-4 py-2">{{ part['orderNumber'] }}</td>
          <td class="px-4 py-2">
            <button *ngIf="part.packageNumber" (click)="printSingleLabel(part)"
              class="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
              title="Imprimir etiqueta de este repuesto">
              <i class="fas fa-print mr-1"></i>Etiqueta
            </button>
          </td>
          <td class="px-4 py-2">{{ getOrderClientName(part['orderNumber'] || '') }}</td>
          <td class="px-4 py-2 text-center">{{ part['amount'] }}</td>
          <td class="px-4 py-2 text-right">{{ part['unitPrice'] | currency }}</td>
          <td class="px-4 py-2 text-right">{{ part['valorDeVenta'] | currency }}</td>
          <td class="px-4 py-2 text-right">{{ part['amount'] * part['unitPrice'] | currency }}</td>
          <td class="px-4 py-2">{{ part.expectedArrivalDate | date:'dd/MM/yyyy' }}</td>
          <td class="px-4 py-2">{{ part.codBr }}</td>
          <td class="px-4 py-2 text-center">
            <span class="px-2 py-1 rounded text-xs"
              [ngClass]="part.needReview ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'">
              {{ part.needReview ? 'Sí' : 'No' }}
            </span>
          </td>
          <td class="px-4 py-2">{{ part.packageNumber || 'N/A' }}</td>
          <td class="px-4 py-2 text-center">
            <input type="checkbox" [checked]="!!part.control" disabled>
          </td>
          <td class="px-4 py-2 text-center">
            <input type="checkbox" [checked]="!!(part.anulado ?? part.Anulado)" disabled>
          </td>
          <td class="px-4 py-2 text-center">
            <input type="checkbox" [checked]="!!(part.trello ?? part.Trello)" disabled>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Panel de resumen debajo de la tabla de repuestos -->
  <div class="mt-4 p-4 bg-white border rounded-lg shadow-sm" *ngIf="!showOrders && getAllSpareParts().length > 0">
    <h3 class="font-semibold text-lg mb-3">Resumen de repuestos</h3>
    <div class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4">
      <div class="bg-blue-50 p-4 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500">Total de costos</p>
            <p class="text-2xl font-bold text-blue-700">{{ getTotalSparePartsCost() | currency }}</p>
          </div>
          <div class="bg-blue-100 p-3 rounded-full">
            <i class="fas fa-dollar-sign text-blue-500 text-xl"></i>
          </div>
        </div>
      </div>

      <div class="bg-green-50 p-4 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500">Total de valor de venta</p>
            <p class="text-2xl font-bold text-green-700">{{ getTotalSparePartsValue() | currency }}</p>
          </div>
          <div class="bg-green-100 p-3 rounded-full">
            <i class="fas fa-chart-line text-green-500 text-xl"></i>
          </div>
        </div>
      </div>

      <div class="bg-purple-50 p-4 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500">Cantidad de repuestos</p>
            <p class="text-2xl font-bold text-purple-700">{{ getAllSpareParts().length }}</p>
          </div>
          <div class="bg-purple-100 p-3 rounded-full">
            <i class="fas fa-cogs text-purple-500 text-xl"></i>
          </div>
        </div>
      </div>
      <div class="bg-indigo-50 p-4 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500">Total de órdenes</p>
            <p class="text-2xl font-bold text-indigo-700">{{ getTotalOrdersCount() }}</p>
          </div>
          <div class="bg-indigo-100 p-3 rounded-full">
            <i class="fas fa-clipboard-list text-indigo-500 text-xl"></i>
          </div>
        </div>
      </div>
      <div class="bg-rose-50 p-4 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500">Repuestos anulados</p>
            <p class="text-2xl font-bold text-rose-700">{{ getAnnulledSparePartsInFilteredViewCount() }}</p>
          </div>
          <div class="bg-rose-100 p-3 rounded-full">
            <i class="fas fa-ban text-rose-500 text-xl"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mensaje cuando no hay órdenes -->
<div *ngIf="filteredOrdersList.length === 0 && !loading" class="text-center py-8 text-gray-500">
  No se encontraron órdenes con los criterios de búsqueda actuales.
</div>

<!-- Leyenda de colores para estados -->
<div class="mt-4 p-3 bg-gray-100 rounded-lg shadow-sm">
  <h3 class="font-semibold mb-2">Referencias de estados:</h3>
  <div class="flex flex-wrap gap-2">
    <div class="flex items-center">
      <span class="inline-block w-4 h-4 bg-blue-100 border border-blue-500 mr-1 rounded"></span>
      <span>Creado</span>
    </div>
    <div class="flex items-center">
      <span class="inline-block w-4 h-4 bg-orange-100 border border-orange-500 mr-1 rounded"></span>
      <span>Llegó / En Proceso</span>
    </div>
    <div class="flex items-center">
      <span class="inline-block w-4 h-4 bg-green-100 border border-green-500 mr-1 rounded"></span>
      <span>Finalizado</span>
    </div>
    <div class="flex items-center">
      <span class="inline-block w-4 h-4 bg-red-100 border border-red-500 mr-1 rounded"></span>
      <span>Cancelado / Atención</span>
    </div>
    <div class="flex items-center">
      <span class="inline-block w-4 h-4 bg-purple-100 border border-purple-500 mr-1 rounded"></span>
      <span>Pendiente / Repuestos Pendientes</span>
    </div>
  </div>
</div>

<!-- Modal para ver detalles de la orden -->
<div *ngIf="selectedOrder" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0" (click)="closeModal()" (keyup.escape)="closeModal()">
  <div id="order-history-order-modal-content" class="bg-white rounded-lg shadow-lg w-11/12 max-w-6xl max-h-[90vh] overflow-y-auto" tabindex="0"
    (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center">
      <h2 class="text-xl font-bold">
        {{ isDuplicatingOrder ? 'Duplicar Orden (con cambios)' : ('Detalles de la Orden #' + selectedOrder.orderNumber) }}
      </h2>
      <button (click)="closeModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="p-4">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div>
          <h3 class="font-semibold mb-2">Información General</h3>
          <div class="space-y-2">
            <div class="flex flex-col">
              <label for="order-id" class="text-sm text-gray-600">ID:</label>
              <input id="order-id" type="text" [(ngModel)]="selectedOrder.orderId" class="p-2 border rounded w-full"
                disabled>
            </div>
            <div class="flex flex-col">
              <label for="order-creation-date" class="text-sm text-gray-600">Fecha de Creación:</label>
              <input id="order-creation-date" type="date" [(ngModel)]="selectedOrderCreationDate"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="order-number" class="text-sm text-gray-600">Número de Orden:</label>
              <input id="order-number" type="text" [(ngModel)]="selectedOrder.orderNumber"
                [required]="isDuplicatingOrder"
                [class.border-red-500]="isDuplicateOrderNumberMissing()"
                class="p-2 border rounded w-full">
              <small *ngIf="isDuplicateOrderNumberMissing()" class="text-red-600 text-xs mt-1">
                Campo obligatorio para guardar la orden duplicada.
              </small>
            </div>
            <div class="flex flex-col">
              <label for="order-siniestro" class="text-sm text-gray-600">Siniestro:</label>
              <input id="order-siniestro" type="text" [(ngModel)]="selectedOrder.siniestro"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="order-invoice" class="text-sm text-gray-600">Factura:</label>
              <input id="order-invoice" type="text" [(ngModel)]="selectedOrder.invoiceNumber"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="order-status" class="text-sm text-gray-600">Estado:</label>
              <select id="order-status" [(ngModel)]="selectedOrder.orderStatus" class="p-2 border rounded w-full">
                <option *ngFor="let status of orderStatus" [value]="status">{{ status }}</option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Cliente y Proveedor</h3>
          <div class="space-y-2">
            <div class="flex flex-col">
              <label for="client-name" class="text-sm text-gray-600">Cliente:</label>
              <input id="client-name" type="text" [(ngModel)]="selectedOrder.clientName"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="client-phone" class="text-sm text-gray-600">Teléfono Cliente:</label>
              <input id="client-phone" type="text" [(ngModel)]="selectedOrder.clientPhone"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="provider-name" class="text-sm text-gray-600">
                Proveedor<span *ngIf="isDuplicatingOrder" class="text-red-600"> *</span>:
              </label>
              <select id="provider-name" [(ngModel)]="selectedOrder.providerName"
                class="p-2 border rounded w-full"
                [class.border-red-500]="isDuplicateOrderProviderMissing()">
                <option *ngIf="isDuplicatingOrder" [ngValue]="''" disabled>Seleccione un proveedor</option>
                <option *ngFor="let providerName of getProviderOptions(selectedOrder.providerName); trackBy: trackByIndex" [value]="providerName">
                  {{ providerName }}
                </option>
              </select>
              <small *ngIf="isDuplicateOrderProviderMissing()" class="text-red-600 text-xs mt-1">
                Debe seleccionar un proveedor para la orden duplicada.
              </small>
            </div>
            <div class="flex flex-col">
              <label for="provider-phone" class="text-sm text-gray-600">Teléfono Proveedor:</label>
              <input id="provider-phone" type="text" [(ngModel)]="selectedOrder.providerPhone"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="employee-name" class="text-sm text-gray-600">Vendedor:</label>
              <select id="employee-name" [(ngModel)]="selectedOrder.employeeName" class="p-2 border rounded w-full">
                <option *ngFor="let employee of employeeNames" [value]="employee">{{ employee }}</option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <h3 class="font-semibold mb-2">Detalles Adicionales</h3>
          <div class="space-y-2">
            <div class="flex flex-col">
              <label for="arrival-date" class="text-sm text-gray-600">Fecha de Llegada:</label>
              <input id="arrival-date" type="date" [(ngModel)]="selectedOrderArrivalDate"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="delivery-address" class="text-sm text-gray-600">Dirección de Entrega:</label>
              <input id="delivery-address" type="text" [(ngModel)]="selectedOrder.deliveryAddress"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="car-model" class="text-sm text-gray-600">Vehículo:</label>
              <input id="car-model" type="text" [(ngModel)]="selectedOrder.carMakeModel"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col">
              <label for="is-export" class="text-sm text-gray-600">Es Exportación:</label>
              <select id="is-export" [(ngModel)]="selectedOrder.isExport" class="p-2 border rounded w-full">
                <option value="si">Sí</option>
                <option value="no">No</option>
              </select>
            </div>
            <div class="flex flex-col">
              <label for="cliente-uy" class="text-sm text-gray-600">Cliente UY:</label>
              <select id="cliente-uy" [(ngModel)]="selectedOrder.clienteUY" class="p-2 border rounded w-full"
                (change)="updateFilteredSparePartStatus(selectedOrder.clienteUY)">
                <option value="AUTOCOMERCIAL">AUTOCOMERCIAL</option>
                <option value="SERIMPORT">SERIMPORT</option>
              </select>
            </div>
            <div class="flex flex-col">
              <label for="workshop-id" class="text-sm text-gray-600">Taller Asignado:</label>
              <div class="flex items-center gap-2 flex-wrap">
                <select id="workshop-id" [(ngModel)]="selectedOrder.workshopId" (change)="onWorkshopChange($event)"
                  class="p-2 border rounded flex-1 min-w-0">
                  <option [value]="null">Sin asignar</option>
                  <option *ngFor="let workshop of workshops" [value]="workshop.workshopId">
                    {{ workshop.name }} ({{ workshop.city }})
                  </option>
                </select>
                <button *ngIf="selectedOrder.workshopId" type="button"
                  (click)="openWorkshopInfo(selectedOrder.workshopId)"
                  class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm rounded whitespace-nowrap shrink-0"
                  title="Ver información del taller">
                  <i class="fas fa-info-circle mr-1"></i> Ver datos del taller
                </button>
              </div>
              <div class="flex justify-center mt-2">
                <button type="button" (click)="openCreateWorkshopModal()"
                  class="px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm rounded whitespace-nowrap">
                  <i class="fas fa-plus mr-1"></i> Crear nuevo taller
                </button>
              </div>
            </div>
            <div class="flex flex-col">
              <label for="send-yes-no" class="text-sm text-gray-600">Enviar:</label>
              <select id="send-yes-no" [(ngModel)]="selectedOrder.sendYesOrNo" class="p-2 border rounded w-full">
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            </div>
            <div class="flex flex-col md:col-span-2">
              <label for="order-emergent-comment" class="text-sm text-gray-600">Comentario emergente:</label>
              <input id="order-emergent-comment" type="text" [(ngModel)]="selectedOrder.emergentComment"
                class="p-2 border rounded w-full">
            </div>
            <div class="flex flex-col bg-blue-50 p-3 rounded border border-blue-200">
              <div class="text-sm text-blue-700 mb-1">
                <i class="fas fa-info-circle mr-1"></i>
                <strong>Números de Exportación</strong>
              </div>
              <p class="text-xs text-blue-600">
                Cada repuesto ahora tiene su propio número de exportación. Puedes editarlo individualmente haciendo clic
                en cada repuesto.
              </p>
            </div>
          </div>
        </div>
      </div>

      <h3 class="font-semibold mb-2">Repuestos ({{ selectedOrder.spareParts?.length || 0 }})</h3>
      <div class="overflow-x-auto">
        <div class="flex justify-between items-center mb-2">
          <div class="text-sm text-gray-500">
            <i class="fas fa-info-circle mr-1"></i> Haz clic en cualquier celda de un repuesto para editarlo
          </div>
          <button (click)="toggleSparePartComponent()" [disabled]="isDuplicatingOrder"
            [attr.title]="isDuplicatingOrder ? 'Guarda primero la orden duplicada para agregar nuevos repuestos' : ''"
            class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-plus mr-1"></i> Agregar Repuesto
          </button>
        </div>
        <table class="min-w-full bg-white border">
          <thead>
            <tr class="bg-gray-100">
              <th class="px-2 py-2 border text-center w-12" title="Estado de empaquetado">📦</th>
              <th class="px-4 py-2 border">Nombre</th>
              <th class="px-4 py-2 border">🇪🇸 Español</th>
              <th class="px-4 py-2 border">🇧🇷 Portugués</th>
              <th class="px-4 py-2 border">Código</th>
              <th class="px-4 py-2 border">Estado</th>
              <th class="px-4 py-2 border">Cantidad</th>
              <th class="px-4 py-2 border">Precio Unitario</th>
              <th class="px-4 py-2 border">Total</th>
              <th class="px-4 py-2 border">Fecha de Llegada</th>
              <th class="px-4 py-2 border">Comentarios</th>
              <th class="px-4 py-2 border">Comentario emergente</th>
              <th class="px-4 py-2 border">Núm. Paquete</th>
              <th class="px-4 py-2 border">Núm. Exportación</th>
              <th class="px-4 py-2 border text-center">FANT?</th>
              <th class="px-4 py-2 border text-center">Recompra</th>
              <th class="px-4 py-2 border text-center">Control</th>
              <th class="px-4 py-2 border text-center">Anulado</th>
              <th class="px-4 py-2 border text-center">Trello</th>
              <th class="px-4 py-2 border">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let part of selectedOrder.spareParts || []; trackBy: trackBySparePartId" class="hover:bg-gray-100"
              [class.selected-row]="part === selectedSparePart"
              [class.last-edited-row]="part.sparePartId === lastEditedSparePartId" (click)="openSparePartModal(part)"
              [ngClass]="getOrderDetailSparePartRowClass(part)"
              title="Haz clic para editar este repuesto">
              <td class="px-2 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)"
                title="{{ getPackagingStatusTextWithVehicle(part) }}"
                [class]="getPackagingStatusClass(getSparePartPackagingStatus(part.sparePartId))">
                <span *ngIf="getSparePartPackagingStatus(part.sparePartId) || part.transportType || part.TransportType"
                  class="text-lg" [innerHTML]="getPackagingStatusIconWithVehicle(part)">
                </span>
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.sparePartName }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <span *ngIf="part.sparePartNameEs" class="text-blue-600 font-medium">{{ part.sparePartNameEs }}</span>
                <span *ngIf="!part.sparePartNameEs" class="text-gray-400 italic text-sm">No definido</span>
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <span *ngIf="part.sparePartNamePt" class="text-green-600 font-medium">{{ part.sparePartNamePt }}</span>
                <span *ngIf="!part.sparePartNamePt" class="text-gray-400 italic text-sm">No definido</span>
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.productCode }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                [ngClass]="getProductStatusClass(computeDisplayProductStatus(part))"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ computeDisplayProductStatus(part) }}
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.amount }}
              </td>
              <td class="px-4 py-2 border text-right cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.unitPrice | currency }}
              </td>
              <td class="px-4 py-2 border text-right cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.amount * part.unitPrice | currency }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.expectedArrivalDate | date:'dd/MM/yyyy' }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.comments }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)"
                [title]="part.emergentComment || part.effectiveEmergentComment || ''">
                {{ part.emergentComment || part.effectiveEmergentComment || '-' }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                {{ part.packageNumber || 'N/A' }}
              </td>
              <td class="px-4 py-2 border cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <span *ngIf="part.exportNumber && part.exportNumber !== ''"
                  class="export-number bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm">
                  <i class="fas fa-shipping-fast mr-1"></i>{{ part.exportNumber }}
                </span>
                <span *ngIf="!part.exportNumber || part.exportNumber === ''" class="text-gray-400 text-sm">
                  Sin asignar
                </span>
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <div class="inline-flex items-center justify-center gap-1">
                  <input type="checkbox" [checked]="!!(part.isFant ?? part.IsFant)" disabled>
                  <span *ngIf="getFantUrgency(part) as urgency"
                    class="inline-block w-3.5 h-3.5 rounded-full"
                    [class.bg-green-500]="urgency === 'green'"
                    [class.bg-yellow-400]="urgency === 'yellow'"
                    [class.bg-red-500]="urgency === 'red'"
                    [title]="urgency === 'green' ? 'Puede esperar' : urgency === 'yellow' ? 'Atención' : 'Urgente'"></span>
                </div>
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <input type="checkbox" [checked]="!!(part.recompra ?? part.Recompra)" disabled>
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <input type="checkbox" [checked]="!!(part.control ?? part.Control)" disabled>
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <input type="checkbox" [checked]="!!(part.anulado ?? part.Anulado)" disabled>
              </td>
              <td class="px-4 py-2 border text-center cursor-pointer hover:bg-blue-50"
                (click)="$event.stopPropagation(); openSparePartModal(part)" title="Haz clic para editar este repuesto">
                <input type="checkbox" [checked]="!!(part.trello ?? part.Trello)" disabled>
              </td>
              <td class="px-4 py-2 border text-center">
                <div class="flex justify-center gap-2">
                  <button (click)="$event.stopPropagation(); openSparePartModal(part)"
                    class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs" title="Editar repuesto">
                    <i class="fas fa-edit mr-1"></i>Editar
                  </button>
                  <button (click)="$event.stopPropagation(); duplicateSparePartWithChanges(part)"
                    class="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-xs" title="Duplicar repuesto">
                    <i class="fas fa-clone mr-1"></i>Duplicar
                  </button>
                  <button *ngIf="part.packageNumber" (click)="$event.stopPropagation(); printSingleLabel(part)"
                    class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs"
                    title="Imprimir etiqueta de este repuesto">
                    <i class="fas fa-print mr-1"></i>Etiqueta
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="bg-gray-50">
              <td colspan="7" class="px-4 py-2 text-right font-bold">Total:</td>
              <td class="px-4 py-2 border text-right font-bold">{{ getOrderTotal(selectedOrder) | currency }}</td>
              <td colspan="4"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Panel de resumen para la orden seleccionada -->
      <div class="mt-4 p-4 bg-gray-50 border rounded-lg shadow-sm">
        <h3 class="font-semibold text-lg mb-3">Resumen de la orden</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="bg-blue-50 p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">Total de costos</p>
                <p class="text-2xl font-bold text-blue-700">{{ getOrderCost(selectedOrder) | currency }}</p>
              </div>
              <div class="bg-blue-100 p-3 rounded-full">
                <i class="fas fa-dollar-sign text-blue-500 text-xl"></i>
              </div>
            </div>
          </div>

          <div class="bg-green-50 p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">Total de valor de venta</p>
                <p class="text-2xl font-bold text-green-700">{{ getOrderSaleValue(selectedOrder) | currency }}</p>
              </div>
              <div class="bg-green-100 p-3 rounded-full">
                <i class="fas fa-chart-line text-green-500 text-xl"></i>
              </div>
            </div>
          </div>

          <div class="bg-purple-50 p-4 rounded-lg shadow-sm">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">Total de repuestos</p>
                <p class="text-2xl font-bold text-purple-700">{{ selectedOrder.spareParts?.length || 0 }}</p>
              </div>
              <div class="bg-purple-100 p-3 rounded-full">
                <i class="fas fa-cogs text-purple-500 text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 border-t flex justify-end space-x-2 flex-wrap gap-2">
      <button (click)="saveChanges()" [disabled]="!canSaveOrderForm()"
        class="px-4 py-2 rounded flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
        [class.bg-blue-500]="canSaveOrderForm()" [class.hover:bg-blue-600]="canSaveOrderForm()"
        [class.bg-gray-400]="!canSaveOrderForm()" [class.text-white]="true">
        <i class="fas fa-save mr-2"></i>
        {{ isDuplicatingOrder ? 'Guardar Orden Duplicada' : 'Guardar Cambios de Orden' }}
      </button>
      <button *ngIf="selectedOrder" (click)="duplicateOrderWithChanges()"
        class="bg-indigo-500 hover:bg-indigo-600 text-white px-4 py-2 rounded flex items-center">
        <i class="fas fa-clone mr-2"></i>
        Duplicar Orden
      </button>
      <button *ngIf="selectedOrder" (click)="generateLabelsAndPackage(selectedOrder, false)"
        [disabled]="!canGeneratePackages(selectedOrder)"
        class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
        <i class="fas fa-box mr-2"></i>
        Generar Paquetes
      </button>
      <button *ngIf="selectedOrder" (click)="generateLabelsAndPackage(selectedOrder, true)"
        class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded flex items-center">
        <i class="fas fa-print mr-2"></i>
        Generar Paquetes e Imprimir
      </button>
      <button *ngIf="selectedOrder && !isDuplicatingOrder" (click)="deleteOrder(selectedOrder)"
        class="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded flex items-center">
        <i class="fas fa-trash mr-2"></i>
        Eliminar Orden
      </button>
      <button (click)="closeModal()" class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal crear nuevo taller (detalle de orden) -->
<div *ngIf="showCreateWorkshopModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <h3 class="text-lg font-semibold mb-4">Crear Nuevo Taller</h3>
    <form [formGroup]="createWorkshopForm" (ngSubmit)="createWorkshop()">
      <div class="space-y-4">
        <div class="form-control">
          <label class="label"><span class="label-text">Nombre del taller *</span></label>
          <input type="text" formControlName="name" class="input input-bordered" placeholder="Ej: Taller Central" required>
        </div>
        <div class="form-control">
          <label class="label"><span class="label-text">Dirección</span></label>
          <input type="text" formControlName="address" class="input input-bordered" placeholder="Dirección del taller">
        </div>
        <div class="form-control">
          <label class="label"><span class="label-text">Teléfono</span></label>
          <input type="text" formControlName="phoneNumber" class="input input-bordered" placeholder="Número de teléfono">
        </div>
        <div class="form-control">
          <label class="label"><span class="label-text">Ciudad *</span></label>
          <input type="text" formControlName="city" class="input input-bordered" placeholder="Ej: Montevideo" required>
        </div>
        <div class="form-control">
          <label class="label"><span class="label-text">Departamento</span></label>
          <input type="text" formControlName="department" class="input input-bordered" placeholder="Ej: Montevideo">
        </div>
        <div class="form-control">
          <label class="label"><span class="label-text">Empresa</span></label>
          <select formControlName="company" class="select select-bordered">
            <option value="AUTOCOMERCIAL">AUTOCOMERCIAL</option>
            <option value="SERIMPORT">SERIMPORT</option>
          </select>
        </div>
      </div>
      <div class="flex justify-end space-x-2 mt-6">
        <button type="button" (click)="cancelCreateWorkshop()" class="btn btn-ghost">Cancelar</button>
        <button type="submit" class="btn btn-primary" [disabled]="createWorkshopForm.invalid || creatingWorkshop">
          <span *ngIf="creatingWorkshop" class="loading loading-spinner loading-sm mr-2"></span>
          Crear Taller
        </button>
      </div>
    </form>
  </div>
</div>
<!-- Modal información del taller (detalle de orden) -->
<div *ngIf="showWorkshopInfoModal && selectedWorkshopInfo"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Información del Taller</h3>
      <button (click)="closeWorkshopInfo()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="space-y-3">
      <div>
        <label class="text-sm font-medium text-gray-600">Nombre:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.name }}</p>
      </div>
      <div *ngIf="selectedWorkshopInfo.address">
        <label class="text-sm font-medium text-gray-600">Dirección:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.address }}</p>
      </div>
      <div *ngIf="selectedWorkshopInfo.phoneNumber">
        <label class="text-sm font-medium text-gray-600">Teléfono:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.phoneNumber }}</p>
      </div>
      <div *ngIf="selectedWorkshopInfo.city">
        <label class="text-sm font-medium text-gray-600">Ciudad:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.city }}</p>
      </div>
      <div *ngIf="selectedWorkshopInfo.department">
        <label class="text-sm font-medium text-gray-600">Departamento:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.department }}</p>
      </div>
      <div *ngIf="selectedWorkshopInfo.company">
        <label class="text-sm font-medium text-gray-600">Empresa:</label>
        <p class="text-gray-900">{{ selectedWorkshopInfo.company }}</p>
      </div>
    </div>
    <div class="flex justify-end mt-6">
      <button (click)="closeWorkshopInfo()" class="btn btn-ghost">Cerrar</button>
    </div>
  </div>
</div>

<!-- Modal para editar repuesto -->
<div *ngIf="selectedSparePart" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0" (click)="closeSparePartModal()" (keyup.escape)="closeSparePartModal()">
  <div id="order-history-spare-part-modal-content" class="bg-white rounded-lg shadow-lg w-11/12 max-w-4xl max-h-[90vh] overflow-y-auto" tabindex="0"
    (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center gap-2">
      <h2 class="text-xl font-bold">
        {{ isDuplicatingSparePart ? 'Duplicar Repuesto (con cambios)' : 'Editar Repuesto' }}
      </h2>
      <div class="flex items-center gap-2">
        <button type="button" class="px-3 py-1 bg-gray-100 rounded hover:bg-gray-200" (click)="toggleAldanaForm()">Aldana</button>
        <button (click)="closeSparePartModal()" class="text-gray-500 hover:text-gray-700">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="p-4">
      <!-- Información del Producto -->
      <div *ngIf="showAldanaForm" class="border rounded-md p-3 mb-4 bg-gray-50">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Interno:</label>
            <input type="text" [(ngModel)]="selectedSparePart.interno" class="p-2 border rounded w-full">
          </div>
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Externo:</label>
            <input type="text" [(ngModel)]="selectedSparePart.externo" class="p-2 border rounded w-full">
          </div>
          <div class="flex flex-col">
            <label class="text-sm text-gray-600">Fecha de comunicado:</label>
            <input type="date" [(ngModel)]="selectedSparePartFechaComunicado" class="p-2 border rounded w-full">
          </div>
          <div class="flex flex-col">
            <label class="text-sm text-gray-600 mb-2">Color:</label>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let color of aldanaColorOptions"
                type="button"
                class="w-8 h-8 border rounded"
                [title]="color.name"
                [ngStyle]="{
                  'background-color': color.hex,
                  'border-color': selectedSparePart.color === color.value ? '#2563eb' : '#9ca3af',
                  'box-shadow': selectedSparePart.color === color.value ? '0 0 0 2px rgba(37,99,235,0.35)' : 'none'
                }"
                (click)="selectAldanaColor(color.value)">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <!-- Identificación / Nombre -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Nombre del Repuesto (General):</label>
          <input type="text" [(ngModel)]="selectedSparePart.sparePartName" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">🇪🇸 Nombre en Español (Para etiquetas):</label>
          <input type="text" [(ngModel)]="selectedSparePart.sparePartNameEs" class="p-2 border rounded w-full"
            placeholder="Nombre en español">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">🇧🇷 Nombre en Portugués (Para Excel):</label>
          <input type="text" [(ngModel)]="selectedSparePart.sparePartNamePt" class="p-2 border rounded w-full"
            placeholder="Nome em português">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Código del Producto:</label>
          <input type="text" [(ngModel)]="selectedSparePart.productCode" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Proveedor del repuesto:</label>
          <select [(ngModel)]="selectedSparePart.providerName" class="p-2 border rounded w-full">
            <option *ngFor="let providerName of getProviderOptions(selectedSparePart.providerName); trackBy: trackByIndex" [value]="providerName">
              {{ providerName }}
            </option>
          </select>
        </div>

        <!-- Estado y seguimiento -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Estado del Producto:</label>
          <select [(ngModel)]="selectedSparePart.productStatus" class="p-2 border rounded w-full">
            <option *ngFor="let status of filteredSparePartDeliveryStatus" [value]="status">{{ status }}</option>
          </select>
        </div>

        <div class="flex flex-col p-2 rounded reception-status-field"
          [ngClass]="getReceptionStatusFieldClass(selectedSparePart.receptionStatus)">
          <label class="text-sm font-medium">Recepción Física:</label>
          <select [(ngModel)]="selectedSparePart.receptionStatus" class="p-2 border rounded w-full">
            <option *ngFor="let opt of sparePartReceptionStatusOptions" [value]="opt">
              {{ opt === '' ? 'PENDIENTE' : opt }}
            </option>
          </select>
          <small class="text-gray-500 text-xs mt-1">Confirmación cuando el repuesto llega físicamente (o incidencia).</small>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600" for="shippingStatus">Envio:</label>
          <select [(ngModel)]="selectedSparePart.shippingStatus" class="p-2 border rounded w-full">
            <option *ngFor="let status of shippingSparePartOptions" [value]="status">{{ status }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Día y hora de llegada:</label>
          <input type="datetime-local" [(ngModel)]="selectedSparePartPhysicalArrivalDateTime"
            class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Orden Nueva:</label>
          <input type="text" [(ngModel)]="selectedSparePart.newOrderNumber" class="p-2 border rounded w-full" placeholder="Opcional">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Fecha de Llegada Esperada:</label>
          <input type="text" [(ngModel)]="selectedSparePartArrivalDate" class="p-2 border rounded w-full"
            placeholder="DD/MM/AAAA">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Fecha de Exportación:</label>
          <input type="date" [(ngModel)]="selectedSparePartExportDate" class="p-2 border rounded w-full">
        </div>

        <!-- Cantidad y valores -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Cantidad:</label>
          <input type="text" [(ngModel)]="selectedSparePart.amount" name="amount" class="p-2 border rounded w-full"
            (input)="handleNumericInput($event)">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Precio Unitario:</label>
          <input type="text" [(ngModel)]="selectedSparePart.unitPrice" name="unitPrice"
            class="p-2 border rounded w-full" (input)="handleNumericInput($event)">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Valor de Venta:</label>
          <input type="text" [(ngModel)]="selectedSparePart.valorDeVenta" name="valorDeVenta"
            class="p-2 border rounded w-full" (input)="handleNumericInput($event)">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">País:</label>
          <input type="text" [(ngModel)]="selectedSparePart.country" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Peso Neto:</label>
          <input type="text" [(ngModel)]="selectedSparePart.netWheight" name="netWheight"
            class="p-2 border rounded w-full" (input)="handleNumericInput($event)">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Peso Bruto:</label>
          <input type="text" [(ngModel)]="selectedSparePart.grossWheight" name="grossWheight"
            class="p-2 border rounded w-full" (input)="handleNumericInput($event)">
        </div>

        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Nota Fiscal:</label>
          <input type="text" [(ngModel)]="selectedSparePart.taxNote" class="p-2 border rounded w-full">
        </div>

        <!-- Checks juntos -->
        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Checks:</label>
          <div class="flex flex-wrap gap-x-6 gap-y-2 mt-2">
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.recompra" class="mr-2">
              <span class="text-sm text-gray-700">Recompra</span>
            </label>
            <span class="inline-flex items-center gap-2">
              <label class="inline-flex items-center">
                <input type="checkbox" [(ngModel)]="selectedSparePart.isFant" class="mr-2" (ngModelChange)="onFantCheckboxChanged($event)">
                <span class="text-sm text-gray-700">FANT</span>
              </label>
              <span class="inline-flex items-center gap-1" *ngIf="selectedSparePart.isFant">
                <button type="button" title="Puede esperar" (click)="setFantUrgency('green')"
                  class="w-4 h-4 rounded-full bg-green-500 border-2"
                  [class.border-gray-900]="selectedSparePart.fantUrgency === 'green'"
                  [class.border-transparent]="selectedSparePart.fantUrgency !== 'green'"
                  [class.ring-2]="selectedSparePart.fantUrgency === 'green'"
                  [class.ring-green-800]="selectedSparePart.fantUrgency === 'green'"></button>
                <button type="button" title="Atención" (click)="setFantUrgency('yellow')"
                  class="w-4 h-4 rounded-full bg-yellow-400 border-2"
                  [class.border-gray-900]="selectedSparePart.fantUrgency === 'yellow'"
                  [class.border-transparent]="selectedSparePart.fantUrgency !== 'yellow'"
                  [class.ring-2]="selectedSparePart.fantUrgency === 'yellow'"
                  [class.ring-yellow-700]="selectedSparePart.fantUrgency === 'yellow'"></button>
                <button type="button" title="Urgente" (click)="setFantUrgency('red')"
                  class="w-4 h-4 rounded-full bg-red-500 border-2"
                  [class.border-gray-900]="selectedSparePart.fantUrgency === 'red'"
                  [class.border-transparent]="selectedSparePart.fantUrgency !== 'red'"
                  [class.ring-2]="selectedSparePart.fantUrgency === 'red'"
                  [class.ring-red-800]="selectedSparePart.fantUrgency === 'red'"></button>
              </span>
            </span>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.control" class="mr-2">
              <span class="text-sm text-gray-700">Control</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.anulado" class="mr-2">
              <span class="text-sm text-gray-700">Anulado</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.trello" class="mr-2">
              <span class="text-sm text-gray-700">Trello</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.devZureo" class="mr-2">
              <span class="text-sm text-gray-700">DevZureo</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.entradaSage" class="mr-2">
              <span class="text-sm text-gray-700">Entrada Sage</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.controleSeba" class="mr-2">
              <span class="text-sm text-gray-700">Controle Seba</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.okAnulacao" class="mr-2">
              <span class="text-sm text-gray-700">Ok Anulação</span>
            </label>
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="selectedSparePart.facturado" class="mr-2">
              <span class="text-sm text-gray-700">Facturado</span>
            </label>
          </div>
        </div>

        <!-- Paquete / Exportación -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Número de Paquete:</label>
          <input type="text" [(ngModel)]="selectedSparePart.packageNumber" class="p-2 border rounded w-full bg-gray-100"
            placeholder="Asignado automáticamente al generar etiquetas" readonly>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">
            <i class="fas fa-shipping-fast mr-2 text-blue-500"></i>
            Número de Exportación:
          </label>
          <input type="text" [(ngModel)]="selectedSparePart.exportNumber"
            class="p-2 border rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: EXP-001, ABC123, 001">
          <small class="text-gray-500 text-xs mt-1">
            <i class="fas fa-info-circle mr-1"></i>
            Cada repuesto puede tener su propio número de exportación
          </small>
        </div>

        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Empaquetador:</label>
          <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
            {{ selectedSparePart.packager || '—' }}
          </div>
          <small class="text-gray-500 text-xs mt-1">Se asigna al confirmar empaquetado; no es editable desde aquí.</small>
        </div>

        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Última exportación (camión):</label>
          <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
            {{ selectedSparePart.lastExportedAt ? (selectedSparePart.lastExportedAt | date:'dd/MM/yyyy HH:mm') : '—' }}
          </div>
          <small class="text-gray-500 text-xs mt-1">Fecha en que pasó a EXPORTADO (carga al camión). Se conserva al cambiar de estado.</small>
        </div>

        <!-- Comentarios -->
        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Comentarios:</label>
          <textarea [(ngModel)]="selectedSparePart.comments" class="p-2 border rounded w-full" rows="3"></textarea>
        </div>

        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Comentario emergente:</label>
          <textarea [(ngModel)]="selectedSparePart.emergentComment" class="p-2 border rounded w-full" rows="2"></textarea>
          <small *ngIf="selectedSparePart.effectiveEmergentComment && !selectedSparePart.emergentComment"
            class="text-xs text-amber-700 mt-1">
            Heredado de la orden: {{ selectedSparePart.effectiveEmergentComment }}
          </small>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Estado de devolución:</label>
          <select [(ngModel)]="selectedSparePart.returnStatus" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Estado de devolución LOG:</label>
          <select [(ngModel)]="selectedSparePart.returnLogStatus" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnLogStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Motivo de devolución:</label>
          <select [(ngModel)]="selectedSparePart.returnReason" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnReasonOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Transportadoras:</label>
          <select [(ngModel)]="selectedSparePart.returnCarrier" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnCarrierOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">NFD:</label>
          <input type="text" [(ngModel)]="selectedSparePart.nfd" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Situación ML:</label>
          <select [(ngModel)]="selectedSparePart.mlStatus" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of mlStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Prazo ML:</label>
          <input type="date" [(ngModel)]="selectedSparePartMlDeadline" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">FRETE DEV:</label>
          <select [(ngModel)]="selectedSparePart.freteDev" class="p-2 border rounded w-full">
            <option value="">Sin definir</option>
            <option *ngFor="let option of freteDevOptions" [value]="option">{{ option }}</option>
          </select>
        </div>

        <div class="flex flex-col col-span-1 md:col-span-2">
          <label class="text-sm text-gray-600">Detalles Adicionales:</label>
          <textarea [(ngModel)]="selectedSparePart.returnDetails" class="p-2 border rounded w-full" rows="2" placeholder="Detalles de la devolución (opcional)"></textarea>
        </div>

        <!-- Documentación BR -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">NCM:</label>
          <input type="text" [(ngModel)]="selectedSparePart.ncm" class="p-2 border rounded w-full">
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Código BR:</label>
          <input type="text" [(ngModel)]="selectedSparePart.codBr" class="p-2 border rounded w-full">
        </div>

        <!-- Poco usado / al fondo -->
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">¿Está Dañado?</label>
          <select [(ngModel)]="selectedSparePart.isDamaged" class="p-2 border rounded w-full">
            <option *ngFor="let option of damagedStateOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Remito:</label>
          <input type="text" [(ngModel)]="selectedSparePart.shippingReceipt" class="p-2 border rounded w-full">
          <a
            [href]="getDacTrackingUrl(selectedSparePart.shippingReceipt)"
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-blue-600 underline mt-1 break-all"
          >
            Rastrear en DAC
          </a>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">¿Necesita Revisión?</label>
          <select [(ngModel)]="selectedSparePart.needReview" class="p-2 border rounded w-full">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Sí</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Taller de la orden:</label>
          <div class="p-2 border rounded w-full bg-gray-100 text-gray-700">
            {{ selectedSparePart.workshopName || selectedOrder?.workshopName || '-' }}
          </div>
        </div>
        <div class="flex flex-col">
          <label class="text-sm text-gray-600">Enviar:</label>
          <select [(ngModel)]="selectedSparePart.sendYesOrNo" class="p-2 border rounded w-full">
            <option value="true">Sí</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>

      <div *ngIf="isDuplicatingSparePart && !isDuplicatingOrder" class="mt-2 mb-4">
        <label class="text-sm text-gray-600">Orden destino para el repuesto duplicado:</label>
        <input
          type="text"
          [(ngModel)]="duplicateSparePartTargetOrderNumber"
          (ngModelChange)="onDuplicateSparePartTargetOrderNumberChange($event)"
          class="p-2 border rounded w-full"
          placeholder="Ingrese el número de orden destino (ej: 1542)">
        <small *ngIf="duplicateSparePartTargetOrderErrorMessage" class="text-red-600 text-xs mt-1 block">
          {{ duplicateSparePartTargetOrderErrorMessage }}
        </small>
        <small class="text-gray-500 text-xs mt-1 block">
          Si el número no existe, el sistema mostrará una alerta y no guardará.
        </small>
      </div>
    </div>

    <div class="p-4 border-t flex justify-end space-x-2 sticky bottom-0 bg-white z-10">
      <button (click)="saveSparePartChanges()" [disabled]="!canSaveSparePartForm()"
        class="px-4 py-2 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed"
        [class.bg-blue-500]="canSaveSparePartForm()" [class.hover:bg-blue-600]="canSaveSparePartForm()"
        [class.bg-gray-400]="!canSaveSparePartForm()">
        {{ isDuplicatingSparePart ? 'Guardar Repuesto Duplicado' : 'Guardar Cambios' }}
      </button>
      <button *ngIf="selectedSparePart && selectedOrder" (click)="duplicateSparePartWithChanges()"
        class="px-4 py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600">
        Duplicar
      </button>
      <button *ngIf="selectedSparePart && selectedOrder && !isDuplicatingSparePart"
        (click)="deleteSparePart(selectedSparePart, selectedOrder)"
        class="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">
        Eliminar Repuesto
      </button>
      <button (click)="closeSparePartModal()" class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
        Cancelar
      </button>
    </div>
  </div>
</div>

<div *ngIf="showLowSaleRatioConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
  <div class="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4" (click)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center">
      <h2 class="text-xl font-bold text-red-700">{{ lowSaleRatioConfirmTitle }}</h2>
      <button type="button" (click)="cancelLowSaleRatioAction()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="p-4">
      <p class="text-gray-700 mb-2">
        Se detectaron repuestos con <strong>V.Venta / P.Unitario menor o igual a 11</strong>.
      </p>
      <p class="text-gray-700 mb-3">¿Deseas continuar y guardar igual?</p>
      <div class="max-h-52 overflow-y-auto border border-red-200 bg-red-50 rounded p-3">
        <p class="text-sm font-semibold text-red-800 mb-2">Repuestos que no cumplen:</p>
        <ul class="list-disc list-inside text-sm text-red-700 space-y-1">
          <li *ngFor="let label of lowSaleRatioViolationLabels">{{ label }}</li>
        </ul>
      </div>
    </div>
    <div class="p-4 border-t flex justify-end gap-2">
      <button type="button" (click)="cancelLowSaleRatioAction()"
        class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Cancelar
      </button>
      <button type="button" (click)="confirmLowSaleRatioAction()"
        class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
        Guardar igual
      </button>
    </div>
  </div>
</div>

<!-- Modal para crear carpeta exportada -->
<div *ngIf="showCreateFolderModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0" (click)="closeCreateFolderModal()" (keyup.escape)="closeCreateFolderModal()">
  <div class="bg-white rounded-lg shadow-lg w-96 max-w-[90vw]" tabindex="0" (click)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center">
      <h2 class="text-xl font-bold">Crear Carpeta Exportada</h2>
      <button (click)="closeCreateFolderModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="p-4">
      <div class="mb-4">
        <label for="folder-name" class="block text-sm font-medium text-gray-700 mb-2">Nombre de la carpeta:</label>
        <input id="folder-name" type="text" [(ngModel)]="folderName"
          class="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Ingrese el nombre de la carpeta">
      </div>

      <div class="mb-4">
        <label for="folder-description" class="block text-sm font-medium text-gray-700 mb-2">Descripción
          (opcional):</label>
        <textarea id="folder-description" [(ngModel)]="folderDescription" rows="3"
          class="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Ingrese una descripción de la carpeta"></textarea>
      </div>

      <div class="bg-gray-50 p-3 rounded-md mb-4">
        <p class="text-sm text-gray-600">
          <strong>Órdenes a incluir:</strong> {{ totalFilteredOrders }} órdenes filtradas
        </p>
        <p class="text-sm text-gray-500 mt-1">
          Se exportarán todas las órdenes que cumplen con los filtros actuales.
        </p>
      </div>
    </div>

    <div class="p-4 border-t flex justify-end space-x-2">
      <button (click)="closeCreateFolderModal()" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Cancelar
      </button>
      <button (click)="createExportedFolder()" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Continuar
      </button>
    </div>
  </div>
</div>

<!-- Modal de confirmación -->
<div *ngIf="showConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0" (click)="closeConfirmModal()" (keyup.escape)="closeConfirmModal()">
  <div class="bg-white rounded-lg shadow-lg w-96 max-w-[90vw]" tabindex="0" (click)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center">
      <h2 class="text-xl font-bold">Confirmar Creación de Carpeta</h2>
      <button (click)="closeConfirmModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="p-4">
      <p class="text-gray-700 mb-4">
        ¿Está seguro que desea crear la carpeta <strong>"{{ folderName }}"</strong>
        con {{ totalFilteredOrders }} órdenes?
      </p>

      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
        <p class="text-sm text-yellow-700">
          <i class="fas fa-info-circle mr-1"></i>
          Esta acción generará archivos de exportación y puede tomar algunos minutos.
        </p>
      </div>
    </div>

    <div class="p-4 border-t flex justify-end space-x-2">
      <button (click)="closeConfirmModal()" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Cancelar
      </button>
      <button (click)="confirmCreateFolder()" class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
        Confirmar
      </button>
    </div>
  </div>
</div>

<!-- Modal de progreso de creación de carpeta -->
<div *ngIf="isCreatingFolder" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0">
  <div class="bg-white rounded-lg shadow-lg w-96 max-w-[90vw]" tabindex="0" (click)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b">
      <h2 class="text-xl font-bold">Creando Carpeta Exportada</h2>
    </div>

    <div class="p-4">
      <div class="mb-4">
        <div class="w-full bg-gray-200 rounded-full h-3 relative overflow-hidden">
          <!-- Barra de progreso principal -->
          <div
            class="bg-gradient-to-r from-blue-500 to-blue-600 h-3 rounded-full transition-all duration-300 ease-in-out relative"
            [style.width.%]="folderProgress">
            <!-- Efecto de animación de ondas -->
            <div
              class="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-progress-wave">
            </div>
            <!-- Efecto de brillo que se mueve -->
            <div
              class="absolute inset-0 bg-gradient-to-r from-transparent via-blue-300 to-transparent opacity-50 animate-progress-shine">
            </div>
            <!-- Efecto de partículas brillantes -->
            <div class="absolute inset-0 animate-progress-particles">
              <div class="absolute top-1 left-1/4 w-1 h-1 bg-white rounded-full opacity-60 animate-bounce"></div>
              <div class="absolute top-1 left-1/2 w-1 h-1 bg-white rounded-full opacity-60 animate-bounce"
                style="animation-delay: 0.5s;"></div>
              <div class="absolute top-1 left-3/4 w-1 h-1 bg-white rounded-full opacity-60 animate-bounce"
                style="animation-delay: 1s;"></div>
            </div>
          </div>
          <!-- Indicador de carga animado cuando está en progreso -->
          <div *ngIf="folderProgress > 0 && folderProgress < 100"
            class="absolute top-0 right-0 h-3 w-3 bg-blue-400 rounded-full animate-pulse"></div>
          <!-- Efecto de borde brillante -->
          <div *ngIf="folderProgress > 0 && folderProgress < 100"
            class="absolute inset-0 rounded-full border-2 border-blue-300 animate-progress-border"></div>
        </div>
        <p class="text-sm text-gray-600 mt-2">{{ folderProgressMessage }}</p>
      </div>

      <div *ngIf="folderProgress === 100 && createdFolderUrl" class="mt-4">
        <a [href]="createdFolderUrl" target="_blank"
          class="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700">
          <i class="fas fa-download mr-2"></i>
          Descargar Carpeta
        </a>
      </div>

      <!-- Botón de cancelar durante la exportación -->
      <div *ngIf="canCancelExport && folderProgress > 0 && folderProgress < 100" class="mt-4">
        <button (click)="cancelExport()"
          class="inline-flex items-center px-4 py-2 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors">
          <i class="fas fa-times mr-2"></i>
          Cancelar Exportación
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Componente para agregar repuestos -->
<app-add-spare-part *ngIf="openAddSparePartComponent && selectedOrder" [orderId]="selectedOrder.orderId"
  [clienteUY]="selectedOrder.clienteUY" (close)="toggleSparePartComponent()"></app-add-spare-part>

<style>
  /* Estilos para ordenación */
  .sortable-header {
    cursor: pointer;
    user-select: none;
    position: relative;
    padding-right: 18px;
    /* Espacio para el indicador de ordenación */
  }

  .sortable-header:hover {
    background-color: #f0f0f0;
  }

  .sort-indicator {
    display: inline-block;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Estilo para el repuesto recién editado */
  .last-edited-row {
    animation: edited-row-glow 2.2s ease-out;
  }

  .fant-row {
    background-color: #f3e8ff !important;
  }

  .fant-row:hover {
    background-color: #e9d5ff !important;
  }

  .fant-row td {
    background-color: inherit;
  }

  .fant-row td:hover {
    background-color: inherit !important;
  }

  .anulado-row {
    background-color: #fecaca !important;
  }

  .anulado-row:hover {
    background-color: #fca5a5 !important;
  }

  .anulado-row td {
    background-color: inherit;
  }

  .anulado-row td:hover {
    background-color: inherit !important;
  }

  .delay-row-yellow {
    box-shadow: inset 4px 0 0 #facc15;
  }

  .delay-row-orange {
    box-shadow: inset 4px 0 0 #fb923c;
  }

  .delay-row-red {
    box-shadow: inset 4px 0 0 #f87171;
  }

  .delay-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.5rem;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 700;
    border: 1px solid transparent;
  }

  .delay-yellow {
    background: #fef9c3;
    color: #854d0e;
    border-color: #facc15;
  }

  .delay-orange {
    background: #ffedd5;
    color: #9a3412;
    border-color: #fb923c;
  }

  .delay-red {
    background: #fee2e2;
    color: #991b1b;
    border-color: #f87171;
  }

  @keyframes edited-row-glow {
    0% {
      box-shadow: inset 0 0 0 9999px rgba(250, 204, 21, 0.35);
    }
    100% {
      box-shadow: inset 0 0 0 9999px rgba(250, 204, 21, 0);
    }
  }

  /* Animaciones para la barra de progreso */
  @keyframes progress-wave {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  @keyframes progress-shine {
    0% {
      transform: translateX(-100%);
    }

    50% {
      transform: translateX(0%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  .animate-progress-wave {
    animation: progress-wave 2s ease-in-out infinite;
  }

  .animate-progress-shine {
    animation: progress-shine 1.5s ease-in-out infinite;
  }

  /* Animación de pulso para el indicador */
  @keyframes pulse {

    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0.5;
    }
  }

  .animate-pulse {
    animation: pulse 1s ease-in-out infinite;
  }

  /* Animación para partículas brillantes */
  .animate-progress-particles {
    animation: progress-particles 2s ease-in-out infinite;
  }

  @keyframes progress-particles {

    0%,
    100% {
      opacity: 0.6;
    }

    50% {
      opacity: 1;
    }
  }

  /* Animación para el borde brillante */
  .animate-progress-border {
    animation: progress-border 1.5s ease-in-out infinite;
  }

  @keyframes progress-border {

    0%,
    100% {
      border-color: rgba(59, 130, 246, 0.5);
    }

    50% {
      border-color: rgba(59, 130, 246, 1);
    }
  }

  /* Animación de rebote para las partículas */
  @keyframes bounce {

    0%,
    20%,
    53%,
    80%,
    100% {
      transform: translateY(0);
    }

    40%,
    43% {
      transform: translateY(-3px);
    }

    70% {
      transform: translateY(-1px);
    }

    90% {
      transform: translateY(-2px);
    }
  }

  .animate-bounce {
    animation: bounce 1s infinite;
  }

  /* Estilos para indicadores de estado de empaquetado */
  .packaging-indicator {
    transition: all 0.3s ease;
    border-radius: 4px;
    font-size: 1.2em;
  }

  .packaging-indicator:hover {
    transform: scale(1.1);
  }

  .packaging-indicator.empaquetado {
    background-color: #fef3c7;
    /* Amarillo claro */
    border: 1px solid #f59e0b;
    /* Amarillo oscuro */
    color: #92400e;
    /* Marrón oscuro */
  }

  .packaging-indicator.exportado {
    background-color: #dbeafe;
    /* Azul claro */
    border: 1px solid #3b82f6;
    /* Azul */
    color: #1e40af;
    /* Azul oscuro */
  }

  .packaging-indicator.enviado {
    background-color: #d1fae5;
    /* Verde claro */
    border: 1px solid #10b981;
    /* Verde */
    color: #065f46;
    /* Verde oscuro */
  }

  /* Animación sutil para los indicadores */
  .packaging-indicator span {
    display: inline-block;
    transition: transform 0.2s ease;
  }

  .packaging-indicator:hover span {
    transform: scale(1.2);
  }
</style>

<!-- Modal para seleccionar repuestos antes de imprimir etiquetas -->
<div *ngIf="showLabelSelectionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  tabindex="0" (click)="closeLabelSelectionModal()" (keyup.escape)="closeLabelSelectionModal()">
  <div class="bg-white rounded-lg shadow-lg w-11/12 max-w-4xl max-h-[90vh] overflow-y-auto" tabindex="0"
    (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
    <div class="p-4 border-b flex justify-between items-center bg-gray-50">
      <h2 class="text-xl font-bold">Seleccionar Repuestos para Imprimir Etiquetas</h2>
      <button (click)="closeLabelSelectionModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <div class="p-4">
      <div class="mb-4 flex justify-between items-center">
        <p class="text-gray-600">
          Seleccione los repuestos cuyas etiquetas desea imprimir:
        </p>
        <div class="flex items-center gap-2">
          <input type="checkbox" [checked]="areAllLabelsSelected()" (change)="toggleAllLabelsSelection()"
            class="cursor-pointer" id="selectAllLabels">
          <label for="selectAllLabels" class="text-sm font-medium cursor-pointer">
            Seleccionar todos ({{ sparePartsForLabelSelection.length }})
          </label>
        </div>
      </div>

      <div class="border rounded-lg overflow-hidden">
        <table class="min-w-full bg-white">
          <thead class="bg-gray-100">
            <tr>
              <th class="px-4 py-2 border text-center w-12"></th>
              <th class="px-4 py-2 border text-left">Nombre</th>
              <th class="px-4 py-2 border text-left">Código</th>
              <th class="px-4 py-2 border text-center">N° Paquete</th>
              <th class="px-4 py-2 border text-center">Cantidad</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let part of sparePartsForLabelSelection; trackBy: trackBySparePartId" class="hover:bg-gray-50"
              [class.bg-blue-50]="isLabelSelected(part.sparePartId)">
              <td class="px-4 py-2 border text-center">
                <input type="checkbox" [checked]="isLabelSelected(part.sparePartId)"
                  (change)="toggleLabelSelection(part.sparePartId)" class="cursor-pointer">
              </td>
              <td class="px-4 py-2 border">
                <div class="font-medium">{{ part.sparePartNameEs || part.sparePartName }}</div>
                <div class="text-sm text-gray-500">{{ part.sparePartName }}</div>
              </td>
              <td class="px-4 py-2 border">{{ part.productCode }}</td>
              <td class="px-4 py-2 border text-center font-mono font-semibold">{{ part.packageNumber }}</td>
              <td class="px-4 py-2 border text-center">{{ part.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p class="text-sm text-blue-700">
          <i class="fas fa-info-circle mr-1"></i>
          <strong>{{ selectedSparePartsForLabels.size }}</strong> de <strong>{{ sparePartsForLabelSelection.length
            }}</strong> repuestos seleccionados
        </p>
      </div>
    </div>

    <div class="p-4 border-t flex justify-end space-x-2 bg-gray-50">
      <button (click)="closeLabelSelectionModal()"
        class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Cancelar
      </button>
      <button (click)="printSelectedLabelsFromModal()" [disabled]="selectedSparePartsForLabels.size === 0"
        class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
        <i class="fas fa-print mr-2"></i>
        Imprimir {{ selectedSparePartsForLabels.size }} Etiqueta(s)
      </button>
    </div>
  </div>
</div>